import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import InnerBanner from './InnerBanner';
import Footer from '../Footer/Footer';
import creative from '../assets/images/creative.png';
import ClientsImage from '../Clients/ClientsImage';

const About = () => {
  return (
    <>
    
    <InnerBanner />



      {/* creative */}
      <section id="section5" className="section">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className='creative'>
                                    <img src={creative} className="" alt="creative" />
                                    <p> <span>ABOUT</span> </p>
                                    <h2>Embrace the World of Digital Stories!</h2>
                                    <h6>Redcube has challenged the boundaries since its inception. Being the early player that squeezed in disruptive technologies into clients’ business objectives to much delight has had cascading effect for all involved. </h6>
                                </div>
                                <div className='creativebtn'>
                                    <a className='bttn3' href="#link">more About US</a>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </section>
      {/* creative end */}



 {/* clients logo section  */}
 <section id="section4" className="section">
        <ClientsImage />
  </section>



  {/* Footer  */}
  <section className='p-0'>
    <Footer />
  </section>
    </>
  );
};

export default About;